import { createFileRoute, Outlet } from "@tanstack/react-router";
import { MARKETING_FONT_LINKS } from "@/lib/seo";
import { CONTENT_PALETTE_CSS } from "@/content-site/lib/palette-styles";
export const Route = createFileRoute("/_content")({
  head: () => ({ links: [...MARKETING_FONT_LINKS] }),
  component: ContentTheme,
});

function ContentTheme() {
  return (
    <>
      <style data-content-palettes dangerouslySetInnerHTML={{ __html: CONTENT_PALETTE_CSS }} />
      <Outlet />
    </>
  );
}
